module.exports = __webpack_public_path__ + "static/media/forkelift.2725fdbf.jpg";